import React from 'react'
import 'styles/d3/input.scss'

const onInputChange = (
  evt,
  containerRef,
  preventInput,
  optionalOnChange,
  type
) => {
  if (containerRef.current.classList.contains('has-error')) {
    containerRef.current.classList.remove('has-error')
  }
  let { value } = evt.target
  if (type === 'number') {
    if (value !== '') {
      value = value
    }
  }
  if (value !== '' && preventInput && preventInput(value)) return
  optionalOnChange(value)
}

const Input = React.forwardRef((props, ref) => {
  const containerRef = React.createRef()
  const {
    className,
    label,
    onChange,
    pretext,
    posttext,
    value,
    inputClassName,
    inputProps,
    placeholder,
    onFocus,
    onBlur,
    type,
    id,
    disabled,
    inline,
    preventInput,
    hasError,
    errorText,
    margin,
    padding,
    step,
    max,
    min,
    autoFocus,
    maxlength
  } = props
  const style = pretext || posttext ? { display: 'inline-block' } : {}
  const hasErrorClass = hasError ? ' has-error' : ''
  const inlineClass = inline ? ' inline' : ''
  const _className = className ? ` ${className}` : ''
  return (
    <div
      style={{ margin, padding }}
      id={id}
      ref={containerRef}
      className={`d3-input${inlineClass}${hasErrorClass}${_className}`}
    >
      <div>
        {label && <p className='label'>{label}</p>}
        {hasError && errorText && (
          <span className='error-text nowrap'>{errorText}</span>
        )}
      </div>
      {pretext && <span className='pretext'>{pretext}</span>}
      <input
        autoFocus={autoFocus}
        {...inputProps}
        className={inputClassName}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        value={value}
        style={style}
        ref={ref}
        onChange={evt =>
          onInputChange(evt, containerRef, preventInput, onChange, type)
        }
        id={id}
        step={step}
        maxLength={maxlength}
        max={max}
        min={min}
      />
      {posttext && <span className='posttext'>{posttext}</span>}
    </div>
  )
})

export default Input
